import { useTranslation } from "react-i18next";

export default function Home()
{
    const { t } = useTranslation();
    return(
        <header className="masthead bg-primary text-white text-center" id="page-top">
            <div className="container d-flex align-items-center flex-column">
            <div className="container">
                <h2 className="page-section-heading text-center text-uppercase text-white" style={{margin:'20px'}}>{t('home_title')}</h2>
                <p className="text-center">{t('home_text')}</p>
            </div>
            </div>
        </header>
    )
}